module.exports = __webpack_public_path__ + "static/media/share_copy_link.5cc6566d.svg";